var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPath23141(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23141",
    "data-name": "Path 23141",
    d: "M44.73,34.376A3.753,3.753,0,0,1,41.482,40H3.99A3.752,3.752,0,0,1,.742,34.376l18.746-32.5a3.752,3.752,0,0,1,6.5,0ZM4.8,36.25H40.675a.47.47,0,0,0,.407-.7L23.142,4.454a.469.469,0,0,0-.812,0L4.392,35.547a.469.469,0,0,0,.406.7m17.938-2.969A3.281,3.281,0,1,1,26.017,30a3.28,3.28,0,0,1-3.281,3.281M20.6,15h4.262a.937.937,0,0,1,.935.993l-.513,8.75a.94.94,0,0,1-.936.882H21.121a.938.938,0,0,1-.936-.882l-.516-8.75A.938.938,0,0,1,20.6,15",
    transform: "translate(-0.236 0)",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPath23141);
export default __webpack_public_path__ + "static/media/Path 23141.79ce61b2e5b398fcc7d1686932baed42.svg";
export { ForwardRef as ReactComponent };